import React from 'react'
import PropTypes from 'prop-types'
import { Disclosure } from '@headlessui/react'
import { ChevronDown, PackageIcon } from 'lucide-react'
import ClassPackageMultiSelect from '../../leevo_ui/KlassForm/ClassPackageMultiSelect'

function ClassPackagesSection({ klassPackages, onChange }) {
  return (
    <Disclosure>
      {({ open }) => (
        <div className="bg-white border border-gray-200 rounded-lg">
          <Disclosure.Button className="flex items-center justify-between w-full px-4 py-3 text-left">
            <div className="flex items-center space-x-2">
              <PackageIcon className="w-5 h-5 text-purple-600" />
              <h3 className="text-base font-semibold text-gray-900">Class Packages</h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-gray-500 transition-transform ${open ? 'transform rotate-180' : ''}`}
            />
          </Disclosure.Button>

          <Disclosure.Panel static className="px-4 pb-4 space-y-4 border-t border-gray-200">
            <div className="mt-4">
              <p className="mb-4 text-sm text-gray-600">
                When a student buys a package, we auto-place them in its classes. When promoted, if their current class
                does not support their new level, we move them to another class in the package.
              </p>
              <label className="block mb-2 text-sm font-medium text-gray-900">Select class packages</label>
              <ClassPackageMultiSelect packages={klassPackages} onChange={onChange} />
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  )
}

ClassPackagesSection.propTypes = {
  klassPackages: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ClassPackagesSection
